import {
    ArrowLeftEndOnRectangleIcon,
    ArrowRightEndOnRectangleIcon,
    Cog6ToothIcon,
    EllipsisVerticalIcon,
    HandRaisedIcon,
    InformationCircleIcon,
    LinkIcon,
    MapIcon,
    PuzzlePieceIcon,
    UserGroupIcon,
    XMarkIcon,
} from "@heroicons/react/24/solid";
import { useState } from "react";
import { config, easings, useSpring, animated } from "@react-spring/web";
import Logo from "../Logo/Logo";
import MenuItem from "../MenuItem/MenuItem";
import "./styles/menu.scss";
import { useUserStore } from "@src/stores/userStore";
import { MenuItems } from "@src/types/global";

const Menu = () => {
    const [open, setOpen] = useState(false);
    const isLoggedIn = useUserStore((state) => state.isLoggedIn);
    const items: MenuItems[] = [
        {
            title: "Logout",
            url: "/logout",
            icon: <ArrowRightEndOnRectangleIcon className="icon--xs" />,
        },
        {
            title: "Help / FAQ",
            url: "/faq",
            icon: <InformationCircleIcon className="icon--xs" />,
        },
        {
            title: "Settings",
            url: "/users/settings",
            icon: <Cog6ToothIcon className="icon--xs" />,
        },
        {
            title: "Submit feedback / bug",
            url: "/feedback",
            icon: <HandRaisedIcon className="icon--xs" />,
        },
        {
            title: "Worlds",
            url: "/worlds",
            icon: <MapIcon className="icon--xs" />,
        },
        {
            title: "Links",
            url: "/links",
            icon: <LinkIcon className="icon--xs" />,
        },
        {
            title: "Height Chart",
            url: "/heightchart",
            icon: <PuzzlePieceIcon className="icon--xs" />,
        },
        {
            title: "Characters",
            url: "/characters",
            icon: <UserGroupIcon className="icon--xs" />,
        },
    ];
    const loggedOutItems: MenuItems[] = [
        {
            title: "Login",
            url: "/login",
            icon: <ArrowLeftEndOnRectangleIcon className="icon--xs" />,
        },
        {
            title: "Help / FAQ",
            url: "/faq",
            icon: <InformationCircleIcon className="icon--xs" />,
        },
        {
            title: "Submit feedback / bug",
            url: "/feedback",
            icon: <HandRaisedIcon className="icon--xs" />,
        },
    ];
    const [props, api] = useSpring(
        () => ({
            from: { opacity: 0, transform: "translate3d(-300px, 400px, 0)" },
            to: { opacity: 0, transform: "translate3d(-300px, 400px, 0)" },
            config: { ...config.stiff, easing: easings.easeInOutCirc },
        }),
        [],
    );

    return (
        <div className="menu">
            {open && (
                <animated.div
                    style={props}
                    className="menu__items"
                    onClick={() => setOpen(false)}
                >
                    {isLoggedIn
                        ? items.map((item, index) => (
                            <MenuItem item={item} key={index} />
                        ))
                        : loggedOutItems.map((item, index) => (
                            <MenuItem item={item} key={index} />
                        ))}
                </animated.div>
            )}
            <div className="menu__button__wrapper">
                <button
                    className={
                        open
                            ? "menu__button menu__button--open"
                            : "menu__button"
                    }
                    type="button"
                    title="Open the menu"
                    tabIndex={1}
                    onClick={() => {
                        api.start({
                            from: {
                                opacity: 0,
                                transform: "translate3d(-300px, 0, 0)",
                            },
                            to: {
                                opacity: 1,
                                transform: "translate3d(0px, 0, 0)",
                            },
                            reverse: open,
                        });
                        setOpen(!open);
                    }}
                >
                    {open ? <XMarkIcon /> : <EllipsisVerticalIcon />}
                </button>
                <Logo size="s" />
            </div>
        </div>
    );
};
export default Menu;
